import { DATA_LAYER_NAME } from '@/src/general/utils/gtm/constants/DatalayerName.constant'

type TInitProps = { code?: string; debug?: boolean; performance?: boolean }

/**
 * Initializes the GTM (Google Tag Manager) with the provided code and debug mode.
 *
 * @param {TInitProps} options - An object containing the code and optional debug flag.
 * @return {void}
 */
export const init = ({ code = '', debug = false }: TInitProps): void => {
  if (code === '') {
    console.error('🛑 GTM - Code is undefined')
    return
  }

  if (!window) {
    console.error('🛑 GTM - Window is undefined')
    return
  }
  // GTM is already initialized
  if (window?.react_gtm?.init) {
    console.error('🛑 GTM - Already initialized')
    return
  }

  window.react_gtm = {
    debug,
  }

  GTMInit(code)
}

/**
 * Initialize Google Tag Manager with the provided code.
 *
 * @param {string} code - The GTM code to initialize with
 */
const GTMInit = (code: string) => {
  if (!window) {
    console.error('🛑 GTM - Window is undefined')
    return
  }
  // Keep tracking that gtm is already initialized
  window.react_gtm.init = true

  const script = document.createElement('script')
  script.innerHTML = `
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', '${DATA_LAYER_NAME}', '${code}')`

  script.id = 'gtm-script'
  const elNoscript = document.createElement('noscript')
  elNoscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${code}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
  document.head.insertBefore(script, document.head.childNodes[1])
  document.body.insertBefore(elNoscript, document.body.childNodes[0])
  elNoscript.id = 'gtm-noscript'

  if (window.react_gtm.debug) {
    console.log(`🟢 GTM initialized with code : ${code}`)
  }
}
